<template>
  <div class="p-lg-4 faq-page" :class="can('manage', 'faq') ? 'bg-white table-shadow' : ''">
    <div class="d-flex justify-content-end mb-4">
      <router-link v-if="can('manage', 'faq')" class="btn btn-green d-flex w-auto" :to="createFAQRoute">
        <span>Add Question</span>
      </router-link>
    </div>
    <div v-if="!can('manage', 'faq')" class="pl-lg-4 pr-lg-5 mb-5 col-12">
      <div class="pl-lg-1 pr-lg-1">
        <h1 class="mb-4">Frågor och svar</h1>
        <p class="font-weight-300 mb-4">Paketportalen</p>
        <p class="font-weight-300 mb-4">
          När användare och kunder hör av sig med vanliga frågor fyller vi på den här sidan. Om du inte hittar det du
          söker kan du använda webbläsarens sökfunktion, Ctrl + F eller motsvarande kommando.
        </p>
        <p class="font-weight-300">
          Det är vi som svarar på dina frågor: Petronella, Eleonor, Patrik och Martin. Du kan alltid kontakta supporten.
        </p>
      </div>
    </div>
    <div class="d-flex col-12 flex-wrap pl-0 pr-0">
      <div v-if="questions.length === 0" class="col-12 text-center">No Results</div>
      <QuestionAnswer
        v-for="question in questions"
        :id="question.id || 0"
        :key="question.id"
        :question="question.question"
        :answer="question.answer"
      />
    </div>
  </div>
</template>

<script lang="ts">
import type { RouterLink } from '@/types/Components/Router'
import type { FAQ } from '@/types/Models/FAQ'
import { defineComponent, computed, onMounted, type ComputedRef } from 'vue'
import { useAccountStore } from '@/store/account'
import { useFaqStore } from '@/store/faq'
import { FAQ_CREATE } from '@/types/router'
import QuestionAnswer from '@/views/Components/FAQ/QuestionAnswer.vue'

export default defineComponent({
  name: 'FAQList',
  components: { QuestionAnswer },
  setup() {
    const accountStore = useAccountStore()
    const faqStore = useFaqStore()

    const ability = computed(() => accountStore.ability)
    const questions: ComputedRef<FAQ[]> = computed(() => faqStore.questions)
    const createFAQRoute: RouterLink = { name: FAQ_CREATE }

    onMounted(() => {
      faqStore.fetchQuestions()
    })

    const can = (rule: string, section: string) => ability.value.can(rule as any, section as any)

    return {
      questions,
      createFAQRoute,
      can,
    }
  },
})
</script>
